import React, {useState} from 'react';
import TextInput from '../../../Shared/TextInput/TextInput';
import Footer from '../Assets/footer';
import {isMobile} from 'react-device-detect';
import Image from '../../../Shared/Image/image';
import EnterIdPartial from '../Assets/enterIdPartial';
import { LogoHelper, LogoType } from 'app/utilities/LogoHelper/helper';

const PhoneInsertFullLogin = (props) => {
  const [phoneNumber, setPhoneNumber] = useState('');
  const [errorInForm, setErrorForm] = useState(null);
  const [isPassportInsert, setPassportInsert] = useState(false);
  const [idNumber, setIdNumber] = useState('');
  const [errorInId, setErrorId] = useState(null);
  const [moreInfo, setMoreInfo] = useState(false);
  const mainLogo = LogoHelper.getLogo(LogoType.MainLogo);

  function is_israeli_id_number(id) {
    id = String(id).trim();
    if (id.length > 9 || isNaN(id)) return false;
    id = id.length < 9 ? ('00000000' + id).slice(-9) : id;
    return (
      Array.from(id, Number).reduce((counter, digit, i) => {
        const step = digit * ((i % 2) + 1);
        return counter + (step > 9 ? step - 9 : step);
      }) %
        10 ===
      0
    );
  }

  const changeIdType = (val) => {
    setPassportInsert(val);
    setIdNumber('');
  };

  const validatePhone = () => {
    const idPattern = /^\d{9}$/;
    const phonePattern = /^0((5\d{1})|([2-4,8-9]\d{0,1}))-?\d{7}$/;
    const passportPattern = /^[A-Za-z0-9]{6,12}$/;
    if (isPassportInsert && !passportPattern.test(idNumber)) {
      setErrorId('רגע... אנחנו לא מזהים את המספר, שננסה שוב?');
    } else {
      if (!isPassportInsert && (!idPattern.test(idNumber) || !is_israeli_id_number(idNumber))) {
        setErrorId('רגע... אנחנו לא מזהים את המספר, שננסה שוב?');
      } else {
        if (!phonePattern.test(phoneNumber) || phoneNumber.length < 9) {
          setErrorForm('עשר ספרות, בלי מקפים - פשוט את מספר הנייד שלך');
        } else {
          let checkResult = props.onclick({phoneNumber: phoneNumber, idNumber: idNumber});
          if (!checkResult) {
            setMoreInfo(true);
          }
        }
      }
    }
  };
  const moreInfoDivText = <div className='more-info'>משהו לא מתאים... שננסה שוב? </div>;
  const moreInfoDivMobile = <div className='more-info'>משהו לא מתאים... שננסה שוב? </div>;
  const moreInfoDiv = isMobile ? moreInfoDivMobile : moreInfoDivText;

  const renderIcon = () => {
    console.log('template icon: ', props.templateIcon);
    if (props.templateIcon != null && props.templateIcon != '') {
      return <Image src={props.templateIcon} alt='icon' className='iconTop' />;
    } else {
      return <Image src={mainLogo} alt='main logo' />;
    }
  };

  return (
    <div className='screenContainer'>
      <form
        onSubmit={async (e) => {
          e.preventDefault();
          await validatePhone();
        }}>
        {renderIcon()}
        <h3 className={`heading withSecondary`}>
          {props.specialTitle && props.specialTitle != '' ? props.specialTitle : 'כניסה לאזור אישי'}
        </h3>
        <h3 className='secondaryHeading'>
          {props.specialText != null && props.specialText != '' ? props.specialText : 'כמה פרטים ואפשר להיכנס'}
        </h3>
        <EnterIdPartial
          onChangeType={changeIdType}
          errorInForm={errorInId}
          onChangeText={(e) => {
            const numberRegex = /^\d+$/;
            const passportRegex = /^[A-Za-z0-9]{0,12}$/;
            console.log({
              passportCheck: isPassportInsert && (e.target.value === '' || passportRegex.test(e.target.value)),
              idCheck: !isPassportInsert && (numberRegex.test(e.target.value) || e.target.value === '') && e.target?.value?.length <= 9,
              val: e.target.value,
            });
            if (
              (!isPassportInsert && (numberRegex.test(e.target.value) || e.target.value === '') && e.target?.value?.length <= 9) ||
              (isPassportInsert && (e.target.value === '' || passportRegex.test(e.target.value)))
            ) {
              setIdNumber(e.target.value);
              setErrorId(null);
              return true;
            }
            return false;
          }}
        />
        {/* <TextInput
                    placeholder={'תעודת זהות או ח.פ.'}
                    value={idNumber}
                    maxLength={'9'}
                    type="text"
                    inputMode="numeric"
                    error={errorInId}

                    onChange={(e) => {
                        const numberRegex = /^\d+$/;
                        if ((numberRegex.test(e.target.value) || e.target.value === '') && e.target?.value?.length <= 9) {
                            setIdNumber(e.target.value);
                            setErrorId(null);
                        }
                    }}
                /> */}
        <TextInput
          placeholder={'טלפון נייד'}
          value={phoneNumber}
          maxLength={'10'}
          type='text'
          inputMode='numeric'
          error={errorInForm}
          onChange={(e) => {
            const numberRegex = /^\d+$/;
            if ((numberRegex.test(e.target.value) || e.target.value === '') && e.target?.value?.length <= 10) {
              setPhoneNumber(e.target.value);
              setErrorForm(null);
            }
          }}
        />
        {props.isReset && <div className='more-info'>הקוד שקיבלתם כבר לא בתוקף. כדי לשמור על הפרטים שלכם, נתחיל את התהליך מחדש</div>}
        {moreInfo && moreInfoDiv}
        <Footer onclick={() => {}} stage={props.stage} />
      </form>
    </div>
  );
};

export default PhoneInsertFullLogin;
